import { State } from "./state";
import { storeInit } from "../../../Store";
import { emptyTimer } from "../filters";

const timers: State.Data = { timers: [], newTimer: emptyTimer() };
export const initial: State.Props = storeInit(timers);
export default initial;
